import PropTypes from 'prop-types';
import React from 'react';
import ReportBox from '../barbersReport/reportBox';

const TotalSales = ({ report, showGiftCards }) => {
  let data = [{
    title: 'In-Shop POS',
    amount: report.paidInShopViaPosAmount,
  }, {
    title: 'In-Shop Cash',
    amount: report.paidInShopOtherAmount,
  }, {
    title: 'Gift Card',
    amount: report.paidViaGiftCardAmount,
  }, {
    title: 'Net Total',
    amount: report.totalAmount,
  }, {
    title: 'Discounts/Promos/Loyalty',
    amount: report.discount,
  }, {
    title: 'Total',
    amount: report.totalAmount + report.discount,
  }];

  if (!showGiftCards) {
    data = data.filter(({ title }) => title !== 'Gift Card');
  }

  const content = data.map((item, index) => (
    <ReportBox key={index} {...item} />
  ));

  return (
    <div className="layout u-mv-">{content}</div>
  );
};

TotalSales.propTypes = {
  report: PropTypes.object.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};

export default TotalSales;
